import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import { Skeleton } from './Skeleton';

interface InfoCardProps {
  title?: ReactNode;
  children: ReactNode;
  headerAction?: ReactNode;
  bottomAction?: ReactNode;
  loading?: boolean;
  classes?: {
    block?: string;
    content?: string;
    bottomAction?: string;
    header?: string;
    title?: string;
  };
}

export const InfoCard: FC<InfoCardProps> = ({
  title,
  loading,
  bottomAction,
  children,
  headerAction,
  classes,
}) => {
  return (
    <div className={classNames('flex flex-col border rounded-xl', classes?.block)}>
      {(title || headerAction) && (
        <div
          className={classNames(
            'w-full flex sm:flex-row flex-col justify-between sm:items-stretch items-start px-6 pt-6 gap-3 flex-wrap',
            {
              'sm:pb-0 pb-2': !classes?.header?.includes('pb-'),
            },
            classes?.header,
          )}
        >
          <div className={classNames('text-base font-medium', classes?.title)}>
            {loading ? <Skeleton width={185} height={15} /> : title}
          </div>
          {headerAction}
        </div>
      )}

      <div
        className={classNames(
          {
            'p-6': !classes?.content?.includes('p-'),
            'flex-1': !classes?.content?.includes('flex-'),
          },
          classes?.content,
        )}
      >
        {children}
      </div>

      {bottomAction && (
        <div
          className={classNames(
            'flex justify-center border-t',
            {
              'px-6': !classes?.bottomAction?.includes('px-'),
              'py-3': !classes?.bottomAction?.includes('py-'),
            },
            classes?.bottomAction,
          )}
        >
          {bottomAction}
        </div>
      )}
    </div>
  );
};
